<template>
  <div class="header-box">
    <!-- 456 -->
    <div class="left-title" v-if="this.userData.siteName != ''">{{ this.userData.siteName }}</div>
    <div class="left-title" v-else>{{ this.userData.username }}</div>
    <div class="the-current-role" v-if="this.userData.username">
      <el-button type="text" class="character-name zhinan" @click="xinshouClick">新手指南</el-button>
      <span class="character-name">欢迎您 {{ this.userData.username }}</span>
      <span class="character-name"><span style="color: #fff; cursor: pointer;" @click="quitClick">退出系统</span></span>
      <!-- <span class="head-sculpture"></span> -->
    </div>
  </div>
</template>

<script>
import { loginOut } from '@/assets/api/api'
import { ElMessage } from 'element-plus'

export default {
  name: 'log',
  components: {
    // HelloWorld
  },
  data() {
    return {
      userData: {}
    }
  },
  created() {
    try {
      this.userData = JSON.parse(localStorage.getItem('user')) || {}
    } catch (e) {
      this.userData = {}
    }
  },
  methods: {
    xinshouClick() {
      this.$router.push({ path: '/new-hand' })
      // window.open({path:'/new-hand'})
    },
    quitClick() {
      loginOut({ id: this.userData.id }).then((res) => {
        if (res.data.msg == '注销成功') {
          this.$router.push({ path: `/login` })
          localStorage.removeItem('token')

          ElMessage({ message: '退出成功', type: 'success', })
        }
      }).catch((err) => {
        console.error('退出登录失败', err)
      })

    }
  }

} 
</script>

<style lang='scss' scoped>
.header-box {
  position: relative;
  width: 100%;
  // width: calc(100% - 240px);
  height: 100%;
  background-color: #229CFA;
  // background: rgb(144, 180, 216);
  // box-shadow: 0px 0px 5px 5px 20px #ccc;
  // box-shadow: 5px 5px 20px 0px rgba(0, 0, 0, 0.1);

  .newhand {
    margin-left: 10px;
  }

  .left-title {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translate(0, -50%);
    font-size: 20px;
    color: #fff;
    font-weight: 700;

  }

  .the-current-role {
    position: absolute;
    right: 30px;
    top: 50%;
    transform: translate(0, -50%);

    .head-sculpture {
      display: inline-block;
      width: 40px;
      height: 40px;
      // background-color: red;
      vertical-align: middle;
      border-radius: 3px;
    }

    .character-name {
      display: inline-block;
      vertical-align: middle;
      font-weight: 700;
      margin-right: 30px;
      color: #fff;
    }

    .zhinan {
      color: #fff;
      margin-top: -8px;
      font-size: 17px
    }
  }
}
</style>